var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"hidden-xs-only pa-0",attrs:{"fluid":""}},[_c('v-breadcrumbs',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }